import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _Map from "@babel/runtime-corejs3/core-js/map";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AssigneeDropdownTemplate from "@Shared/@HandlebarsTemplates/general/_assignee-dropdown.hbs";
import { mapGetters, mapState } from "vuex";
import { COLLABORATORS } from "@Broker/@Modules/clients/board/store/board-getters";
import Select2 from "@Shared/components/inputs/select2";
import { cloneDeep, values } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CollaboratorsSelect",
  components: {
    Select2
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    profile: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [COLLABORATORS])), mapState("BoardStore", {
    collaborators(state) {
      var _context;
      const clientBoard = state.boards.byId[this.boardId];
      if (!clientBoard) return [];
      const boardCollaborators = values(this.COLLABORATORS(this.boardId));
      const allCollaborators = [...boardCollaborators, clientBoard.ownerDetails];
      return [..._valuesInstanceProperty(_context = new _Map(_mapInstanceProperty(allCollaborators).call(allCollaborators, item => [item.username, item]))).call(_context)];
    },
    emptyCollaborators() {
      return _Object$keys(this.collaborators).length === 0;
    }
  })), {}, {
    options() {
      const formatResult = state => $(AssigneeDropdownTemplate(state));
      return {
        templateResult: formatResult,
        allowClear: false,
        closeOnSelect: true,
        dropdownCssClass: "collaborators-vue-select",
        escapeMarkup(markup) {
          return markup;
        }
      };
    }
  }),
  methods: {
    formatData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, ref => {
        ref.id = ref.username;
        ref.text = `${ref.givenName} ${ref.familyName}`;
        return ref;
      });
    },
    handleChange(data, type) {
      this.$emit("change", data, type);
    }
  }
});